var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebinar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.25H7.75V1.5C7.75 1.30109 7.67098 1.11032 7.53033 0.96967C7.38968 0.829018 7.19891 0.75 7 0.75C6.80109 0.75 6.61032 0.829018 6.46967 0.96967C6.32902 1.11032 6.25 1.30109 6.25 1.5V2.25H1.5C1.16899 2.25164 0.851997 2.38387 0.617932 2.61793C0.383866 2.852 0.251643 3.16899 0.25 3.5V11C0.251643 11.331 0.383866 11.648 0.617932 11.8821C0.851997 12.1161 1.16899 12.2484 1.5 12.25H3.4375L2.4125 13.5312C2.28937 13.6875 2.23279 13.886 2.25502 14.0838C2.27725 14.2815 2.37649 14.4625 2.53125 14.5875C2.66547 14.6916 2.83017 14.7487 3 14.75C3.11277 14.7503 3.22416 14.7252 3.32588 14.6765C3.42759 14.6278 3.51702 14.5568 3.5875 14.4688L5.3625 12.25H8.6375L10.4125 14.4688C10.483 14.5568 10.5724 14.6278 10.6741 14.6765C10.7758 14.7252 10.8872 14.7503 11 14.75C11.1698 14.7487 11.3345 14.6916 11.4688 14.5875C11.6235 14.4625 11.7228 14.2815 11.745 14.0838C11.7672 13.886 11.7106 13.6875 11.5875 13.5312L10.5625 12.25H12.5C12.831 12.2484 13.148 12.1161 13.3821 11.8821C13.6161 11.648 13.7484 11.331 13.75 11V3.5C13.7484 3.16899 13.6161 2.852 13.3821 2.61793C13.148 2.38387 12.831 2.25164 12.5 2.25ZM12.25 10.75H1.75V3.75H12.25V10.75Z",
    fill: "#79747E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinar);
export default __webpack_public_path__ + "static/media/Webinar.3447369dcb0c6f8fc10f0e17ad83e029.svg";
export { ForwardRef as ReactComponent };